<template>
    <v-app id="app">
        <router-view></router-view>
    </v-app>
</template>

<script>

export default {
    name: 'App',

    components: {
    },

    data: () => ({
    }),

    mounted() {
    },

    methods: {
    },

    computed: {
    },
}
</script>

<style>

/* mobile */
@media only screen and (max-width: 1400px) {
}

@media only screen and (min-width: 1400px) {
}

#app {
    overflow-x:hidden;
}

/* animations */

.text-focus-in {
    animation: text-focus-in 1s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}

.sub-text-focus-in-1s {
    animation: text-focus-in 1s cubic-bezier(0.550, 0.085, 0.680, 0.530) both 1s;
}

.sub-text-focus-in-hs {
    animation: text-focus-in 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both 1s;
}

@keyframes text-focus-in {
    0% {
        filter: blur(5px);
        opacity: 0;
    }
    100% {
        filter: blur(0px);
        opacity: 1;
    }
}

.display-none {
    opacity: 0 !important;
}

</style>
